import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SectionTitle from '../SectionTitle/index';
import styles from './practiceDescription.module.css';
import { isDesktop } from '../../../../config';

class PracticeDescription extends Component {
  static propTypes = {
    description: PropTypes.string,
  };
  state = {
    showMore: false,
  };
  toggle = () => {
    this.setState({ showMore: !this.state.showMore });
  };
  render() {
    const charLimit = isDesktop() ? 270 : 150;
    const showMore = this.state.showMore;
    const description = this.props.description;
    return description ? (
      <div className={styles.container}>
        <SectionTitle className={styles.title} title="About us" />
        {description.length <= charLimit || showMore ? (
          <span className={styles.text}>{description}</span>
        ) : (
          <span className={styles.text}>{`${description.substr(
            0,
            charLimit - 3,
          )}...`}</span>
        )}
        {description.length > charLimit && (
          <span
            className={classnames(styles.readMore, {
              [styles.readLess]: showMore,
            })}
            onClick={this.toggle}
          >
            {' '}
            Read {showMore ? ' less' : ' more'}{' '}
          </span>
        )}
      </div>
    ) : null;
  }
}

export default PracticeDescription;
